const Menu =  [      
  {title: 'Login', name: 'login', meta:{public:true, guest:true}},
  {title: 'Device Register', name: 'device-register', meta:{public:true, guest:true}},  
];

import Remenu from '@/util/remenu'
export default Remenu(Menu);